/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './follow.defs.js'
export { main as default } from './follow.defs.js'
